function bootPackPricing() {
  document.querySelectorAll('[data-pack-pricing]').forEach(bindPackPricing);
}

function bindPackPricing(container) {

  if (container.dataset.bound) return;
  container.dataset.bound = "1";

  const product = JSON.parse(container.querySelector('[data-product-json]').textContent);

  function qty(title){
    const m = title.match(/(\d+)/);
    return m ? parseInt(m[1]) : 1;
  }

  function update(v){
    if (!v) return;

    const pack = qty(v.title);
    const total = v.price/100;
    const unit = Math.round(total/pack);

    container.querySelector('#perBottlePrice').textContent = `₹${unit}`;
    container.querySelector('#totalPrice').textContent = `₹${total}`;

    const c = v.compare_at_price ? v.compare_at_price/100 : 0;
    const ce = container.querySelector('#comparePrice');
    const badge = container.querySelector('#discountBadge');

    if (c > total){
      const d = Math.round(((c-total)/c)*100);
      ce.textContent = `₹${c}`;
      ce.style.display='inline';
      badge.textContent = `${d}% OFF`;
      badge.style.display='inline-block';
    } else {
      ce.style.display='none';
      badge.style.display='none';
    }
  }

  const form = container.closest('form');
  if (form){
    form.addEventListener('change', ()=>setTimeout(refresh,30));
    form.addEventListener('click', ()=>setTimeout(refresh,30));
  }

  function refresh(){
    const id = form?.querySelector('[name="id"]')?.value;
    const v = product.variants.find(v=>v.id==id) || product.selected_or_first_available_variant;
    update(v);
  }

  refresh();
}

/* Shopify lifecycle */
//bootPackPricing();
//document.addEventListener('DOMContentLoaded', bootPackPricing);
//document.addEventListener('shopify:section:load', bootPackPricing);
//new MutationObserver(bootPackPricing).observe(document.body,{childList:true,subtree:true});
